import {Component, Inject, Input, OnInit} from '@angular/core';
import {ConfigService} from '../../../../config/config.service';

@Component({
    selector: 'layer-info',
    templateUrl: './layer-info.component.html',
    styleUrls: ['./layer-info.component.css'],
    standalone: false
})
export class LayerInfoComponent implements OnInit {
  @Input() itemFunction: any;

  private _imageUrl: string;

  constructor(
    private _configService: ConfigService,
  ) { }

  ngOnInit() {

    const itemFunc = this._configService.layerListFunctionConfig.functionList.filter(f => f.fkId === this.itemFunction.id);
    this._imageUrl = itemFunc[0].imageUrl;
  }

  get imageUrl(): string {
    return this._imageUrl;
  }

  openImageInNewWindow() {
    window.open(this.imageUrl, '_blank');
  }

}

